import { Suspense } from 'react';

import { Loader } from 'shared';

import { SessionsRecapModal } from 'features/sessions/components/RecapModal';

import { SIZES } from 'shared/components/Modal';
import { useOpenModal } from 'shared/components/Modal/hooks';

import { CoachingSessionRecapMessageContent } from '../config/types/Message';

export const useOpenSessionRecapModal = (
  content: Partial<CoachingSessionRecapMessageContent>
) => {
  return useOpenModal({
    content: (
      <Suspense
        fallback={<Loader data-testid="sessions-recap-dialog-loader" />}
      >
        <SessionsRecapModal />
      </Suspense>
    ),
    props: {
      size: SIZES.SM,
      title: 'Session Recap',
    },
    context: {
      sessionRecap: {
        ...content,
        title: content.subject,
      },
    },
  });
};
